import { format } from 'd3-format';

import './styles/graphic.scss';
import { classify } from './utils/helpers';

export default function (props, container, isMobile) {
  const {
    data,
    initialWidth,
    initialHeight,
    width,
    height,
    x,
    y,
    xAxis,
    yAxis,
    margins,
  } = props;

  // const yTicks = isMobile ? 8 : 8;
  const yTicks = isMobile ? [0, -5000, -10000, -15000, -20000] : [0, -5000, -10000, -15000, -20000];
  const fmtComma = format(',');
  const fmtSI = format('.0f');
  // const fmtSI = format('.1s');

  const ticksMobi = ['2008-01-01', '2010-01-01', '2012-01-01', '2014-01-01', '2016-01-01', '2018-01-01', '2020-01-01'];
  const ticksDesk = ['2008-01-01', '2009-01-01', '2010-01-01', '2011-01-01', '2012-01-01', '2013-01-01', '2014-01-01', '2015-01-01', '2016-01-01', '2017-01-01', '2018-01-01', '2019-01-01', '2020-01-01'];

  /** SET WEEKLY * */
  const selectedDate = '2020-04-01';
  const selectText = '-20.5 million jobs';
  const selectTextMonth = 'April, 2020';

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  const xGrid = g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis(x)
      .tickValues(isMobile ? ticksMobi : ticksDesk)
      .tickFormat(d => (isMobile ? `\u0027${String(d).substring(2, 4)}` : `\u0027${String(d).substring(2, 4)}`)));

  xGrid.selectAll('text')
    .attr('y', 10);

  const yGrid = g.append('g')
    .attr('class', 'y grid')
    .call(yAxis(y)
      // .ticks(yTicks)
      .tickValues(yTicks)
      .tickSize(-width)
      .tickFormat(d => (isMobile
        ? (Math.abs(d) > 999
          ? `${fmtSI(d / 1000).toUpperCase()}M`
          : `${`${fmtComma(d)}`}`)
        : (Math.abs(d) > 9999
          ? `${fmtSI(d / 1000).toUpperCase()}M`
          : `${fmtSI(d / 1000).toUpperCase()}M`))));

  yGrid.selectAll('text')
    .attr('x', -5)
    .filter(d => d === 0)
    .text(0);
  // .remove(); // hide zero

  //  yGrid.selectAll('text')
  //  .filter(d => d < 0)
  // .text(d => `${d.split('K')[0]}M`);

  const group = g.append('g')
    .attr('class', 'data');

  const recessions = group.append('g')
    .attr('class', 'recessions');

  const labels = group.append('g')
    .attr('class', 'labels');

  const bars = group.append('g')
    .attr('class', 'bars');

  const recession = recessions.append('rect')
    .attr('class', 'recession')
    .attr('transform', `translate(${[x('2007-12-01'), 0]})`)
    .attr('width', x('2009-06-01') - x('2007-12-01'))
    .attr('height', height)
    .style('fill', 'grey')
    .style('fill-opacity', 0.09);

  const bar = bars.selectAll('.bar')
    .data(data)
    .enter().append('g')
    .attr('class', 'bar')
    .attr('role', 'list')
    .attr('transform', d => `translate(${[x(d.label), y(d.amt < 0 ? 0 : d.amt)]})`);

  bar.append('title')
    .text(d => `${d.label} (${d.amt})`);

  bar.append('rect')
    // .attr('class', d => (d.label === selectedDate ? `data-new-${classify(d.label)}` : `data-${d.label}`))
    .attr('class', d => (d.amt >= 0 ? `data-${classify(d.label)} data-positive` : `data-${classify(d.label)} data-negative`))
    .attr('width', x.bandwidth())
    .attr('height', d => Math.abs(y(d.amt) - y(0)));

  labels.append('text')
    .attr('class', 'label-recession')
    .attr('transform', `translate(${[x('2007-12-01') + 5, height - 10]})`)
    .attr('text-anchor', 'start')
    .text('Recession');

  // labels.append('text')
  //   .attr('class', 'label-2020')
  //   .attr('transform', `translate(${[x(selectedDate) - 3, y(data[data.length - 1].amt) - 0]})`)
  //   .attr('text-anchor', 'end')
  //   .text(selectText)
  //   .append('tspan')
  //   .text(selectTextMonth)
  //   .attr('x', 0)
  //   .attr('dy', +14);

  const offset = 50;
  // annotation text
  // highlighted area
  labels.append('rect')
    .attr('class', 'data-highlight')
    .attr('transform', `translate(${[x('2010-03-01'), y(600)]})`)
    .attr('width', x('2020-03-01') - x('2010-03-01'))
    .attr('height', y(-1000) - y(600))
    .style('fill-opacity', 0.5);

  labels.append('rect')
    .attr('class', 'label-callout-rule')
    .attr('transform', `translate(${[x('2020-02-01'), y(-12500)]})`)
    .attr('width', isMobile ? 6 : 15)
    .attr('height', 1);

  // labels.append('rect')
  //  .attr('class', 'data-border')
  //  .attr('transform', `translate(${[x('2017-05-01') + 3, y(-10500)]})`)
  //  .attr('width', x.bandwidth() * 32)
  //  .attr('height', y(-3750));

  // labels.append('rect')
  //   .attr('class', 'data-border')
  //   .attr('transform', isMobile ? `translate(${[x('2014-03-01') + 3, y(-10500)]})` : `translate(${[x('2017-03-01') + 3, y(-10500)]})`)
  //   .attr('width', x.bandwidth() * 34)
  //   .attr('height', y(-3750));

  labels.append('text')
    .attr('class', 'labels')
    .attr('transform', `translate(${[x('2015-03-01'), y(-1000) - y(600) + 20]})`)
    .attr('width', x('2016-11-01') - x('2013-07-01'))
    .attr('height', 16)
    .attr('text-anchor', 'middle')
    .text('22.8M jobs gained over 10 years')
    .style('fill-opacity', 0.6);

  labels.append('text')
    .attr('class', 'label-2020-focus')
    .attr('transform', isMobile ? `translate(${[x('2019-10-01') + 3, y(-12500)]})` : `translate(${[x('2019-12-01') + 3, y(-12500)]})`)
    // .attr('transform', isMobile ? `translate(${[width / 2, 105]})` : `translate(${[width / 2, 131]})`)
    .attr('text-anchor', 'end')
    .text(selectText)
    .append('tspan')
    .text(selectTextMonth)
    .attr('x', 0)
    .attr('dy', isMobile ? +20 : +24);
  if (y.domain()[0] < 0) {
    // zero line
    g.append('line')
      .attr('role', 'presentation')
      .attr('class', 'zero-bar')
      .attr('x1', 0)
      .attr('x2', width)
      .attr('y1', y(0))
      .attr('y2', y(0));
  }
}
